import Button from '~/components/Button';
import { CURRENCY, type Plan } from '~/data/plans';
import s from './PlanCard.module.scss';

export default function PlanCard({ plan }: { plan: Plan }) {
  return (
    <div className={`${s.card} ${plan.featured ? s.featured : ''}`}>
      {plan.badge && <div className={s.badge}>{plan.badge}</div>}

      <div className={s.head}>
        <div className={s.name}>{plan.name}</div>
        <div className={s.tagline}>{plan.tagline}</div>
      </div>

      <div className={s.price}>
        <span className={s.cur}>{CURRENCY}</span>
        <span className={s.amt}>{plan.price}</span>
        <span className={s.per}>{plan.period}</span>
      </div>

      <div className={s.calls}>
        <strong>{plan.calls}</strong> API calls / month
      </div>

      <Button
        to={`/payment?plan=${plan.id}`}
        variant={plan.featured ? 'primary' : 'ghost'}
        className={s.cta}
      >
        {plan.cta}
      </Button>
    </div>
  );
}
